import React from "react"

import { styled } from "@mui/material"

// @ts-ignore
import CirrusCornerLogo from "@cirrus/assets/img/logo-corner.svg"
// @ts-ignore
import CirrusLogo from "@cirrus/assets/img/logo-small.svg"
import { useTranslations } from "@cirrus/core/i18n"

export const HeaderContent = styled("div")({
  width: "100%",
  height: "30px",
  display: "flex",
  alignItems: "center",
  gap: "8px",
  // border: "1px solid red",
  padding: "30px 40px 30px 40px",
})

export const HeaderLogo = styled("div")({
  background: `url('${CirrusLogo}') 50% 50% no-repeat`,
  backgroundSize: "contain",
  width: "30px",
  height: "30px",
})

const WelcomeText = styled("h1")({
  width: "auto",
  color: "#423C56",
  fontFeatureSettings: "'liga' off, 'clig' off",
  fontSize: "24px",
  fontStyle: "normal",
  fontWeight: "600",
  lineHeight: "28px" /* 116.667% */
})

export const HeaderWelcome = () => {

  const { i18n } = useTranslations()

  return (
    // <WelcomeText>{i18n("General:WelcomeToCirrus")}</WelcomeText>
    <WelcomeText>Welcome to Cirrus</WelcomeText>
  )
}

export const CornerLogo = styled("div")(({ theme }) => ({
  background: `url('${CirrusCornerLogo}') 50% 50% no-repeat`,
  backgroundSize: "contain",
  width: "9.368rem",
  height: "1.9rem",
  position: "absolute",
  top: "2.8rem",
  left: "2.8rem",

  [theme.breakpoints.down("md")]: {
    display: "none",
  }
}))
